import {Action} from '@ngrx/store';
import {type} from '../../shared';

export const updateBreadCrumbOrderDetailsActionTypes = {
  UPDATE: type('[Update BreadCrumb data] UPDATE')
};

export class UpdateBreadOrderDetailsAction implements Action {
  readonly type = updateBreadCrumbOrderDetailsActionTypes.UPDATE;
  constructor() {}
}

